/*
 * @Description:
 * @Date: 2024-02-02 16:47:33
 */
export function hexToRgba(hex, opacity) {
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  );
}

const _getThemeColor = (index = 1, opacity = 1) => {
  return hexToRgba(
    getComputedStyle(document.documentElement).getPropertyValue(
      `--theme-color-${index}`
    ),
    opacity
  );
};

const _createHtmlBorder1 = () => {
  const mainColor = _getThemeColor();
  return `
  <div style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:3;">
    <div style="width:100%;height:1px;background:#707070;position:absolute;left:0;top:15px;"></div>
    <div style="width:1px;height:100%;background:#707070;position:absolute;left:15px;top:0;"></div>
    <div style="background:${mainColor};width:12px;height:12px;left:2px;top:2px;clip-path: polygon(100% 0, 100% 100%, 0 100%, 100% 0);opacity:0.7;position:absolute;"></div>
  </div>
  `;
};
const _createHtmlBorder2 = () => {
  const mainColor = _getThemeColor();
  return `
  <div style="position:absolute;left:0;top:4px;width:100%;height:calc(100% - 8px);z-index:3;border:1px solid ${mainColor};opacity:0.6;">
    <div style="width:52px;height:9px;position:absolute;right:-1px;top:-4px;background:${mainColor};"></div>
    <div style="width:52px;height:9px;position:absolute;left:-1px;bottom:-4px;background:${mainColor};"></div>
  </div>
  `;
};
const _createHtmlBorder3 = () => {
  const mainColor = _getThemeColor();
  return `
  <div style="position:absolute;left:0;top:4px;width:calc(100% - 4px);height:calc(100% - 24px);z-index:3;border:1px solid ${mainColor};opacity:0.6;">
    <div style="width:45px;height:45px;position:absolute;right:-4px;top:-4px;background:${mainColor};clip-path:polygon(0 0, 100% 0,100% 100%,calc(100% - 9px) 100%, calc(100% - 9px) 8px,0 9px);"></div>
    <div style="position:absolute;left:0;bottom: -12px;background:#fff;padding:0 10px;">
      <div style="width:24px;height:24px;border:1px solid ${mainColor};"></div>
      <div style="width:24px;height:24px;background:${mainColor};margin-left:18px;margin-top:-16px;"></div>
    </div>
  </div>
  `;
};
const _createHtmlBorder4 = () => {
  const mainColor = _getThemeColor();
  return `
  <div style="position:absolute;left:7px;top:4px;width:calc(100% - 14px);height:calc(100% - 10px);z-index:3;border-top:1px solid #C0BEC7;border-bottom:1px solid #C0BEC7;">
    <div style="width:7px;height:calc(100% + 20px);background:${mainColor};opacity:0.6;left:-7px;top:-5px;position:absolute;"></div>
    <div style="width:7px;height:calc(100% + 20px);background:${mainColor};opacity:0.6;right:-7px;top:-5px;position:absolute;"></div>
  </div>
  `;
};

const _createHtmlBorder5 = () => {
  const mainColor = _getThemeColor();
  return `
  <div style="position:absolute;left:0;top:3px;width:100%;height:calc(100% - 6px);z-index:3;border:1px solid ${mainColor};">
    <div style="width:120px;height:6px;background:linear-gradient(90deg, ${mainColor} 80px ,#fff 80px);left:12px;top:-3px;position:absolute;"></div>
    <div style="width:120px;height:6px;background:linear-gradient(90deg, #fff 40px,${mainColor} 40px );right:12px;bottom:-3px;position:absolute;"></div>
  </div>
  `;
};

const _createHtmlBorder6 = () => {
  const mainColor = _getThemeColor();
  return `
    <div style="position:absolute;left:0;top:6px;width:100%;height:1px;z-index:3;border-top:1px solid ${mainColor};">
      <div style="width:12px;height:12px;border-radius:50%;background:${mainColor};left:0px;top:-6px;position:absolute;"></div>
    </div>
    <div style="position:absolute;left:24px;top:6px;width:calc(100% - 24px);height:calc(100% - 12px);z-index:3;border:1px solid ${mainColor};border-top:none;"></div>
  `;
};

export const getBorderFnMap = {
  1: { fn: _createHtmlBorder1, padding: [28, 24, 18, 32] },
  2: { fn: _createHtmlBorder2, padding: [24, 24, 24, 24] },
  3: { fn: _createHtmlBorder3, padding: [18, 24, 45, 24] },
  4: { fn: _createHtmlBorder4, padding: [18, 24, 18, 24] },
  5: { fn: _createHtmlBorder5, padding: [24, 24, 24, 24] },
  6: { fn: _createHtmlBorder6, padding: [24, 18, 24, 48] }
};
